import React from 'react';

import PropTypes from 'prop-types';

import { CountryLink, CountryName, FlagWrapper } from './styles';
import { LightFlagIcon } from '../fromAuth/LightFlagIcon/LightFlagIcon';
import { PromoText } from '../PromoText/PromoText';

const PromoCountryItemPlain = (props) => {
    return (
        <CountryLink href={props.href}>
            <FlagWrapper>
                <LightFlagIcon name={props.flagName} size={'24px'} />
            </FlagWrapper>
            <CountryName>
                <PromoText tag="div" variant="subheader" color="gray40" ellipsis nowrap>
                    {props.countryName}
                </PromoText>
            </CountryName>
        </CountryLink>
    );
};
PromoCountryItemPlain.propTypes = {
    href: PropTypes.string,
    flagName: PropTypes.string,
    countryName: PropTypes.string,
};
export default PromoCountryItemPlain;
